import Model, { toProp, toModel, toModels } from "./Model";
import DocumentCategory from "./DocumentCategory";

/**
 *
 * @class Document
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.8] app/src/model/Document.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

class Document extends Model {
  constructor(modelData) {
    super()

    /** @type string */
    this.id = toProp()

    /** @type string|null */
    this.title = toProp()

    /** @type DocumentCategory[] */
    this.categories = toModels(DocumentCategory)

    /** @type DocumentCategory */
    this.mainCategory = toModel(DocumentCategory)

    this.buildModel(modelData)
  }

  getContentCategory(){
    this.checkProps(
      'categories.key',
      'categories.type',
    )

    for (let i=0; i<this.categories.length; i++){
      if (this.categories[i].type === 'content_type')
        return this.categories[i]
    }

    return null;
  }

  getContentTypeText(){
    this.checkProps(
      'categories.name',
    )

    const contentCategory = this.getContentCategory()

    return contentCategory ? contentCategory.name : null
  }

  getContentTypeKey(){
    this.checkProps(
      'categories.key',
    )

    const contentCategory = this.getContentCategory()

    return contentCategory ? contentCategory.key : null
  }
}

export default Document